<template>
  <div class="relative">
    <div class="rounded shadow overflow-hidden" @click="expand()">
      <slot />
    </div>

    <transition enter-class="opacity-0" leave-to-class="opacity-0">
      <div
        v-show="fullscreen"
        ref="overlay"
        class="bg-black bg-opacity-75 fixed w-screen h-screen p-2 top-0 left-0 flex flex-row items-center transition-opacity z-30 overflow-scroll"
      >
        <div
          @click="close()"
          class="text-white text-6xl absolute top-4 right-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-12 w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreen: false,
    };
  },
  methods: {
    expand() {
      this.fullscreen = true;
      this.$parent.$emit("expand-screenshot");
    },
    close() {
      this.fullscreen = false;
      this.$parent.$emit("close-screenshot");
    },
  },
};
</script>
